module.exports = __webpack_public_path__ + "img/retkilatu_original.43d7fa5f.png";